<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">{{label}}</v-card-title>

    <v-card-text>
        
        <v-form
            v-model="valid"
        >

        <m-text-field
            :label="label"
            v-model="value"
            autofocus
            :rules="rules"
            :hint="hint"
            emoji
        />

         <v-chip
            color="primary"
            class="ma-2"
            label
            small
            v-if="show_message_type"
        >
            {{message_type}}
        </v-chip>

        </v-form>

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!valid"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

export default {

    props: {
        rules: {
            type: Array,
            default: function () { return []; },
        },

        show_message_type: {
            type: Boolean,
            default: function () { return false; }
        },

        force_mms: {
            type: Boolean,
            default: function () { return false; }
        },
    },

    data() {
        return {
            picker_style: null,
            dialog: false,
            label: 'field',
            value: '',
            valid: false,
            hint: null,
        }
    },

    methods: {
        showDialog(label, value, hint) 
        {
            this.label = label;
            this.value = value;
            this.dialog = true; 
            this.hint = hint;
        },
        
        onOk()
        {
            this.dialog = false;
            this.$emit('ok',this.value);
        },
    },

    computed: {
        message_type() {
            if ( this.force_mms )
                return 'MMS';

            return this.$rc.messageType(this.value);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>